import React, { Component } from 'react'
import Link from 'components/Link';
import { FormattedMessage } from 'react-intl';
import Logo from '../Logo';
import './_footer.scss';

import Subscribe from './SubscribeModal';

const FooterNav = (props) => {
    return (
        <div className="navBarContainer">
            <div className="upperNavBar">
                <div className="logoContainer">
                    <Link to="/" className="text-white">
                    <Logo size={40} />
                    <div className="logo-text">
                    <FormattedMessage id="title"/>
                    </div>
                    </Link>
                </div>
                <Subscribe/>
            </div>
            <div className="lowerNavBar">
                <div className="navLinks">
                    <ul>
                        {
                            props.menu && props.menu.map((e, index) =>
                                <li key={index}>
                                    <Link to={e.slug} exact>
                                        <FormattedMessage id={e.label} />
                                    </Link>
                                </li>
                            )
                        }
                    </ul>
                </div>
                <div className="mediaLinks">
                    <ul>
                        {
                            props.mediaLinks && props.mediaLinks.map((e, index) =>
                                <li key={index}>
                                    <a className={e.icon} href={e.path} ></a>
                                </li>
                            )
                        }
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default FooterNav;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js